/**
 * Modal de selección de formato para exportación a Excel
 */

import React from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { EXCEL_FORMATS } from '../utils/constants';

const ExcelFormatModal = ({
  show,
  onHide,
  selectedFormat,
  onFormatSelect,
  onExport,
  loading
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      backdrop={loading ? 'static' : true}
      keyboard={!loading}
      className="excel-format-modal"
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title>
          <FaIcons.FaFileExcel className="me-2" />
          Seleccionar Formato de Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <FaIcons.FaSpinner
              className="fa-spin"
              size={40}
              style={{ color: '#28a745' }}
            />
            <p className="mt-3 fw-bold">Generando archivo Excel...</p>
            <p className="text-muted">
              Por favor espere, esto puede tomar unos momentos.
            </p>
          </div>
        ) : (
          <div>
            <p className="mb-3 text-muted">
              Seleccione el tipo de formato para exportar el reporte:
            </p>

            <div className="d-grid gap-3">
              {/* Opción: Excel Tipo Manifiesto */}
              <Card
                className={`cursor-pointer ${
                  selectedFormat === EXCEL_FORMATS.TIPO_MANIFIESTO
                    ? 'border-success border-3'
                    : ''
                }`}
                onClick={() => onFormatSelect(EXCEL_FORMATS.TIPO_MANIFIESTO)}
                style={{ cursor: 'pointer' }}
              >
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3">
                    <input
                      type="radio"
                      name="excelFormat"
                      checked={selectedFormat === EXCEL_FORMATS.TIPO_MANIFIESTO}
                      onChange={() => onFormatSelect(EXCEL_FORMATS.TIPO_MANIFIESTO)}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">
                      <FaIcons.FaFileAlt className="me-2 text-primary" />
                      Excel Tipo Manifiesto
                    </h6>
                    <small className="text-muted">
                      Formato estructurado para manifiestos de entrega con
                      información detallada de guías.
                    </small>
                  </div>
                </Card.Body>
              </Card>

              {/* Opción: Excel Informativo */}
              <Card
                className={`cursor-pointer ${
                  selectedFormat === EXCEL_FORMATS.INFORMATIVO
                    ? 'border-success border-3'
                    : ''
                }`}
                onClick={() => onFormatSelect(EXCEL_FORMATS.INFORMATIVO)}
                style={{ cursor: 'pointer' }}
              >
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3">
                    <input
                      type="radio"
                      name="excelFormat"
                      checked={selectedFormat === EXCEL_FORMATS.INFORMATIVO}
                      onChange={() => onFormatSelect(EXCEL_FORMATS.INFORMATIVO)}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">
                      <FaIcons.FaInfoCircle className="me-2 text-info" />
                      Excel Informativo
                    </h6>
                    <small className="text-muted">
                      Formato simplificado con información general y resumen de
                      datos.
                    </small>
                  </div>
                </Card.Body>
              </Card>
            </div>

            {selectedFormat && (
              <div className="alert alert-success mt-3 mb-0">
                <FaIcons.FaCheckCircle className="me-2" />
                Formato seleccionado:{' '}
                <strong>
                  {selectedFormat === EXCEL_FORMATS.TIPO_MANIFIESTO
                    ? 'Tipo Manifiesto'
                    : 'Informativo'}
                </strong>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={onExport}
          disabled={!selectedFormat || loading}
        >
          {loading ? (
            <>
              <FaIcons.FaSpinner className="fa-spin me-2" />
              Descargando...
            </>
          ) : (
            <>
              <FaIcons.FaDownload className="me-2" />
              Descargar Excel
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExcelFormatModal;
